import { type Dictionary } from './types/shared.interface';

export const safeParse = <T = Dictionary>(value: string): T => {
  try {
    return JSON.parse(value);
  } catch (_error) {
    return {} as T;
  }
};
